import { DefaultItem, GenericItem } from '../types';

export const defaultLabelGetter = (item: unknown | null) => {
  return item ? (item as DefaultItem).label : '';
};

const defaultFilterBy = (item: string, inputValue: string) =>
  item.includes(inputValue);

export const defaultGetFilteredItems = <TItem extends GenericItem>({
  allItems,
  itemToString,
  inputValue,
  filterBy = defaultFilterBy,
}: {
  allItems: TItem[];
  itemToString: (item: TItem | null) => string;
  inputValue?: string;
  filterBy?: (item: string, inputValue: string) => boolean;
}) => {
  if (!inputValue) {
    return allItems;
  }

  return allItems.filter((item) =>
    filterBy(itemToString(item).toLowerCase(), inputValue.toLowerCase()),
  );
};

export const defaultIsItemDisabled = (item: GenericItem) => !!item.disabled;
